<template>
    <div class="container relative z-10 max-w-3xl mx-auto">
        <div class="pt-8 text-center lg:pt-24">
            <h1 class="mx-auto mb-6 text-3xl font-semibold leading-tight tracking-tight font-noto-sans md:max-w-md lg:max-w-lg xs:text-4xl lg:text-6xl text-grey-darkest">
                We're here to help<br>
                <span class="text-blue">7 days a week</span>
            </h1>

            <h2 class="max-w-md mx-auto mb-12 text-lg md:mb-16 md:text-xl xl:text-2xl">
                Got a question? No problem. Get in touch, and one of our support staff will be happy to help.
            </h2>
        </div>

        <grid-layout class="mb-12">
            <grid-layout-item class="mb-6 md:w-1/3">
                <a
                    :href="`mailto:${contact_email}`"
                    class="block w-full h-full p-6 text-center bg-white rounded shadow hover:shadow-md"
                >
                    <base-svg
                        name="misc-email"
                        class="h-10 mx-auto mb-6"
                    />

                    <h3 class="mb-3 text-lg">
                        Send us an email
                    </h3>

                    <div class="text-grey-darker">
                        <p class="mb-3 text-blue">
                            {{ contact_email }}
                        </p>

                        <p class="mb-3">
                            We’ll usually respond within 24 hours
                        </p>
                    </div>
                </a>
            </grid-layout-item>

            <grid-layout-item class="mb-6 md:w-1/3">
                <callback-requests-store-button
                    class="block w-full h-full p-6 text-center bg-white rounded shadow hover:shadow-md"
                >
                    <base-svg
                        name="misc-telephone"
                        class="h-10 mx-auto mb-6"
                    />

                    <h3 class="mb-3 text-lg">
                        We'll call you
                    </h3>

                    <div class="text-grey-darker">
                        <p class="mb-3 text-blue">
                            Request a callback
                        </p>

                        <p class="mb-3">
                            We'll ring you back
                        </p>
                    </div>
                </callback-requests-store-button>
            </grid-layout-item>

            <grid-layout-item class="mb-6 md:w-1/3">
                <a
                    :href="`tel:${contact_tel}`"
                    class="block w-full h-full p-6 text-center bg-white rounded shadow hover:shadow-md"
                >
                    <base-svg
                        name="misc-telephone"
                        class="h-10 mx-auto mb-6"
                    />

                    <h3 class="mb-3 text-lg">
                        Fancy a chat?
                    </h3>

                    <div class="text-grey-darker">
                        <p class="mb-3 text-blue">
                            {{ contact_tel }}
                        </p>

                        <p class="mb-3">
                            We're usually around 9am to 5pm, Mon to Fri
                        </p>
                    </div>
                </a>
            </grid-layout-item>
        </grid-layout>
    </div>
</template>

<script>
    import _ from 'lodash'
    import HeadMixin from '../../../mixins/head'
    import CallbackRequestsStoreButton from '../../../components/callback-requests-create-button'

    export default {
        mixins: [
            HeadMixin
        ],
        components: {
            CallbackRequestsStoreButton
        },
        computed: {
            contact_tel () {
                return _.preload('contact.telephone', 'n/a')
            },
            contact_email () {
                return _.preload('contact.email', 'n/a')
            }
        },
        methods: {
            head () {
                return {
                    title: 'Contact us'
                }
            }
        }
    }
</script>
